
export default function Guarantee() {
  const guarantees = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Plataforma Segura',
      description: 'Pagamento 100% seguro e protegido'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Suporte Direto',
      description: 'Contato direto com a Raíssa'
    },
    {
      icon: 'ri-medal-fill',
      title: 'Qualidade Garantida',
      description: 'Método testado e aprovado'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-green-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            Você Está <span className="text-green-600">100% Segura</span>
          </h2>
          <p className="text-xl text-gray-600 font-poppins">
            Sua transformação é nossa prioridade e responsabilidade
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {guarantees.map((guarantee, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center border border-green-100"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${guarantee.icon} text-green-600 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 font-poppins">
                {guarantee.title}
              </h3>
              <p className="text-gray-600 text-sm font-inter">
                {guarantee.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-green-100 to-green-50 rounded-3xl p-8 lg:p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-star-fill text-white text-3xl"></i>
            </div>
            
            <h3 className="text-3xl font-bold text-gray-900 mb-6 font-montserrat">
              Garantia de Satisfação
            </h3>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed font-inter">
              Estamos tão confiantes no nosso método que oferecemos total transparência no processo. 
              Você terá acesso completo ao acompanhamento personalizado, ajustes contínuos e suporte 
              direto durante todos os 30 dias da mentoria.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-check-double-line text-green-500 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">Método Comprovado</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-check-double-line text-green-500 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">Acompanhamento Real</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-check-double-line text-green-500 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">Resultados Mensuráveis</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
